<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">受講コース一覧</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section class="page-content__form-group">
          <aside>
            <label for="name" class="input-form__label-title"
              ><span class="input-form__label-required">必須</span
              >受講コースを選択してください。</label
            >
            <select
              id="course-selectbox"
              name="course-selectbox"
              v-model="selectedCourse.id"
              @change="validate"
              class="input-form__selectbox input-form__selectbox"
            >
              <option value="">（選択）</option>
              <option v-for="cr in courses" v-bind:value="cr.id">{{ cr.name }}</option>
            </select>
          </aside>
        </section>
        <section class="page-content__form-group">
          <aside v-show="this.selectedCourse.id != '' && selectedCourse.showTextBox">
            <input
              type="text"
              id="input-course-name"
              name="input-course-name"
              v-model="inputCourseName"
              @blur="validate"
              placeholder="コース名をご入力ください。※ご不明な場合は未入力でも結構です。"
              autofocus
              required
              class="input-form__textbox"
            />
          </aside>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link v-show="isSubmit" to="/application-form" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              コース申込画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /**
   * 次の画面に遷移する前に実行する
   */
  beforeRouteLeave(to, from, next) {
    this.validate();
    next(this.isSubmit); // 入力値検証がNGの場合は遷移できない
  },
  computed: {
    /**
     * コース一覧を取得する
     */
    courses: function () {
      return this.$store.getters['course/courses'];
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result &= this.error === null;
      if (this.error === null) this.saveDataInStore();
      return result;
    },
  },
  async created() {
    // データの初期化処理はrouter.jsで行う
  },
  data() {
    return {
      error: '',
      selectedCourse: {
        id: '',
        rankId: null,
        name: null,
        price: null,
        priceWithTax: null,
        showTextBox: false,
      },
      inputCourseName: null,
    };
  },
  methods: {
    /**
     * 入力値をストアから取得する
     */
    getDataFromStore: function () {
      this.selectedCourse = this.$store.getters['courseApplication/course'];
    },
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      this.$store.commit('courseApplication/setCourse', this.selectedCourse);
    },
    /**
     * 選択データをセットする
     */
    setSelectedCourse: function () {
      for (let course in this.courses) {
        if (this.selectedCourse.id === this.courses[course].id) {
          this.selectedCourse.rankId = this.courses[course].rank_id;
          this.selectedCourse.name = this.inputCourseName
            ? this.courses[course].name + '　（' + this.inputCourseName + '）'
            : this.courses[course].name;
          this.selectedCourse.price = this.courses[course].price;
          this.selectedCourse.priceWithTax = this.courses[course].price_with_tax;
          this.selectedCourse.showTextBox = this.courses[course].show_text_box;
          break;
        }
      }
      //console.log(this.selectedCourse.showTextBox);
    },
    /**
     * 入力内容を検証する
     */
    validate: function () {
      this.setSelectedCourse();

      this.error = null;
      let result = true;

      if (this.selectedCourse.id === null || this.selectedCourse.id === '') {
        this.error = 'コースを選択してください';
        result = false;
      }
      // if (this.selectedCourse.showTextBox && !this.inputCourseName) {
      //   this.error = 'コース名を入力してください';
      //   result = false;
      // }

      // 値を数値型に変換
      this.selectedCourse.rankId = isNaN(this.selectedCourse.rankId)
        ? null
        : parseInt(this.selectedCourse.rankId);
    },
  },
  mounted() {
    this.getDataFromStore();
    this.validate();
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';
@import 'stylesheets/big-radio.scss';

.page-content__course-radio-wrapper {
  padding: 0 0 1rem 0;
}

.page-content__course-description-wrapper {
  padding: 1rem 0 0 0;
}

.page-content__course-description-title {
  font-size: 1rem;
  font-weight: bold;
}

.page-content__course-description-body {
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  font-size: 0.9rem;
}
</style>
